var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',[(_vm.isVisible)?_c('upcoming-event'):_vm._e(),(_vm.isVisible)?_c('chapter-list'):_vm._e(),(_vm.isVisible)?_c('region-map'):_vm._e(),(_vm.isVisible)?_c('community-officers-list',{staticClass:"panelBlock"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }